module.exports = __webpack_public_path__ + "img/icon-notification-on.31557463.svg";